import React from 'react';
import styles from './Layout.module.css';
import classNames from 'classnames';

export type LayoutItemProps = {
  /** Specify the order of elements in the layout, following the direction of the layout's wrap */
  order?: number;
  /** Specify how this layout item aligns, overriding the layout */
  align?: 'start' | 'middle' | 'end';
  /** Set `span` to 50 */
  oneHalf?: boolean;
  /** Set `span` to 33.33 */
  oneThird?: boolean;
  /** Set `span` to 66.66 */
  twoThirds?: boolean;
  /** Set `span` to 25 */
  oneFourth?: boolean;
  /** Set `span` to 50 */
  twoFourths?: boolean;
  /** Set `span` to 75 */
  threeFourths?: boolean;
  /** Set `span` to 20 */
  oneFifth?: boolean;
  /** Set `span` to 40 */
  twoFifths?: boolean;
  /** Set `span` to 60 */
  threeFifths?: boolean;
  /** Set `span` to 80 */
  fourFifths?: boolean;
  /** Set a custom span for this layout item, out of 1 or out of 100%. E.g, `0.5/2` or `50/100` */
  span?: number;
};

export const LayoutItem: React.FC<LayoutItemProps> = ({
  align = 'start',
  order = 1,
  span,
  children,
  ...props
}) => {
  const vars: Record<string, string | number> = {};
  const className = classNames(styles.LayoutItem, {
    [styles.AlignStart]: align === 'start',
    [styles.AlignMiddle]: align === 'middle',
    [styles.AlignEnd]: align === 'end',
    [styles.LayoutOneHalf]: props.oneHalf,
    [styles.LayoutOneThird]: props.oneThird,
    [styles.LayoutTwoThirds]: props.twoThirds,
    [styles.LayoutOneFourth]: props.oneFourth,
    [styles.LayoutTwoFourths]: props.twoFourths,
    [styles.LayoutTwoFourths]: props.threeFourths,
    [styles.LayoutOneFifth]: props.oneFifth,
    [styles.LayoutTwoFifths]: props.twoFifths,
    [styles.LayoutThreeFifths]: props.threeFifths,
    [styles.LayoutFourFifths]: props.fourFifths,
  });

  if (span) vars['--layout-item-width'] = span > 1 ? span / 100 : span;
  if (order) vars['--layout-item-order'] = order;

  return (
    <div className={className} style={vars as React.CSSProperties}>
      {children}
    </div>
  );
};
